"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function OptionsButton({ selected, children, className, forwardedRef, onClick, }) {
    return ((0, jsx_runtime_1.jsx)(Button, { "$selected": selected, className: className, ref: forwardedRef, onClick: onClick, "data-e2e": 'OptionsButton_Button', children: children }));
}
exports.default = OptionsButton;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;

  margin: 0 0 20px 0;
  padding: 0;

  color: ${props => props.$selected
    ? props.theme.backgroundQuaternary
    : props.theme.tools.header.textbox.colors.white};

  font-size: 20px;
  line-height: 20px;

  background-color: ${props => props.$selected
    ? props.theme.tools.header.textbox.colors.white
    : props.theme.backgroundQuinary};

  border: 1px solid
    ${props => props.$selected
    ? props.theme.tools.header.textbox.colors.white
    : props.theme.tools.pen.button.border};
  border-radius: 50%;

  box-shadow: ${props => props.$selected ? props.theme.tools.pen.button.shadow : 'none'};

  transition-timing-function: ease-in;
  transition-duration: 0.2s;
  transition-property: color, background-color, border;
`;
